import React, { Component } from 'react';
import swal from 'sweetalert';
import { translate } from 'react-i18next';

import {clipboard} from 'react-icons-kit/icomoon/clipboard';
import {pencil} from 'react-icons-kit/fa/pencil';
import {print} from 'react-icons-kit/fa/print';
import {fileText} from 'react-icons-kit/fa/fileText';
import {trash} from 'react-icons-kit/fa/trash';
import {pencilSquareO} from 'react-icons-kit/fa/pencilSquareO';
import {laboratory} from '../../../assets/icons/laboratory';
import {clinic} from '../../../assets/icons/clinic';

import BreadcrumbTitle from '../../../components/BreadcrumbTitle';
import TableList from '../../../components/TableList';
import { confirmationModal } from '../../../libs/functions';
import { donationTypeExtraction, offeringCellsDelete, offeringCellsList } from '../../../libs/services';
import RegisterSample from '../../components/RegisterSample';
import SelectSamples from '../../components/SelectSamples';
import { extractions } from '../../../assets/icons/extractions';
import moment from 'moment';
import { ic_local_offer } from 'react-icons-kit/md/ic_local_offer';
import PrintLabel from '../../components/modals/PrintLabel';

class CellBankList extends Component{
    constructor(props){
        super(props);

        this.deleteOffering = this.deleteOffering.bind(this);
        this.editOffering = this.editOffering.bind(this);
        this.getExtractionTypes = this.getExtractionTypes.bind(this);
        this.getList = this.getList.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.newRegister = this.newRegister.bind(this);
        this.showModalDelete = this.showModalDelete.bind(this);
        this.openSampleRegister = this.openSampleRegister.bind(this);
        this.updateList = this.updateList.bind(this);
        this.openSamples = this.openSamples.bind(this);
        this.openClinicHistory = this.openClinicHistory.bind(this);
        this.openMedicalNotes = this.openMedicalNotes.bind(this);
        this.openExtraction = this.openExtraction.bind(this);
        this.onPrint = this.onPrint.bind(this);
        this.openModalPrintLabel = this.openModalPrintLabel.bind(this);
        this.searchresult= this.searchresult.bind(this);
        this.state = {
            extraction_type_id: 'all',
            date_ini: moment().format('YYYY-MM-DD'),
            date_end:moment().format('YYYY-MM-DD'),
            extraction_types: [],

            buttons: [
                {
                    clickFn: 'edit',
                    disabled: false,
                    icon: pencil,
                    title: 'Editar'
                },
                {
                    clickFn: 'delete',
                    disabled: false,
                    icon: trash,
                    title: 'Eliminar',
                }
            ],
            columns: [
                {title:'No.', show: true},
                {title:'Fecha Registro', show: true},
                {title:'No. Muestra', show:true},
                {title:'No. Donación', show:true},
                {title:'Fecha Extracción', show:true},
                {title:'T. Extracción', show:true},
                {title:'T. Donación', show:true},
                {title:'Donante', show:true},
                {title:'Muestras', show:true},
                {title:'Lab.', show:true},
                {title:'Notas Médicas', show:true},
                {title:'H. C.', show:true},
                {title:'Extracción', show:true},
                {title:'Comp. Don.', show:true},
                {title:'Et. Reg', show:true},
                {title:'Et. Ext', show:true},
                {title:'', show:true}
            ],
            list: []
        }
    } 

    componentDidMount() {
        console.log("VALOR INICIAL"+this.state.extraction_type_id);
        this.getExtractionTypes();
        //GET LIST(100) PARA EVITAR LA BUSQUEDA DE INICIO
        this.getList(this.state.extraction_type_id);
        
   console.log("Inicia llenado");
    }

    async deleteOffering(id) {
        let response = offeringCellsDelete(id);

        if (response !== undefined) {
            swal('Registro eliminado');
        }
    }

    editOffering(id) {
        this.props.history.push('/cell_bank/edit/'+id);
    }

    async getExtractionTypes() {
        let response =  await donationTypeExtraction('cells');

        if(response !== undefined) {
            this.setState({ extraction_types: response });
        }
    }

    async getList(et_id){
        let res = await offeringCellsList(et_id, sessionStorage.getItem('health_facilities_id'), this.state.date_ini, this.state.date_end, this.props.waiting); 
        
        if(res !== undefined){
            let list = res.map((r)=>{
                let obj = [{
                    type: 'text',
                    value: r.id
                },{
                    type: 'text',
                    value: moment(r.registration_date).format("DD/MM/YYYY"),
                },{
                    type: 'array',
                    value: r.samples,
                },{
                    type: 'text',
                    value: r.donation_number + (r.cell_number !== null ? ' (' + r.cell_number + ')' : ''),
                },{
                    type: 'text',
                    value: r.donation_date !== null ? moment(r.donation_date).format("DD/MM/YYYY") : '',
                },{
                    type: 'text',
                    value: r.extraction_code,
                },{
                    type: 'text',
                    value: r.donation_code,
                },{
                    type: 'text',
                    value: r.donor_lastnames + ' ' + r.donor_names
                },{
                    type: 'button',
                    properties: {
                        disabled: false,
                        fill: r.flag_samples ? 'data' : 'default',
                        icon: clipboard,
                        size: 'md',
                        title: 'Muestras',
                        variables: {id:r.id, donor_id:r.donor_id},
                        clickFn:'sample_register'
                    }
                },{
                    type: 'button',
                    properties: {
                        disabled: !r.flag_samples,
                        fill: r.flag_samples ? r.flag_laboratory ? 'data' : 'partial-data' : 'default',
                        icon: laboratory,
                        size: 'md',
                        title: 'Resultados Laboratorio',
                        variables: r.id,
                        clickFn:'samples'
                    }
                },{
                    type: 'button',
                    properties: {
                        disabled: false,
                        fill: r.flag_medical_notes ? 'data' : 'default',
                        icon: pencilSquareO,
                        size: 'md',
                        title: 'Notas Médicas',
                        variables: r.id,
                        clickFn:'medical_notes'
                    }
                },{
                    type: 'button',
                    properties: {
                        disabled: false,
                        fill: r.clinic_history_status === '' ? 'default'
                            : r.clinic_history_status === 'PENDING' ? 'partial-data' : 'data',
                        highlight: r.clinic_history_status === 'DIFERIDO' || r.clinic_history_status === 'NOT_RESULTS',
                        icon: clinic,
                        size: 'md',
                        title: 'Historia Clínica',
                        variables: r.id,
                        clickFn:'clinic'
                    }
                },{
                    type: 'button',
                    properties: {
                        disabled: r.clinic_history_status !== 'ACCEPT',
                        fill: r.donation_status === '' ? 'default'
                                : r.donation_status === 'PENDING' ? 'partial-data' : 'data',
                        highlight: r.donation_status === 'REJECT',
                        icon: extractions,
                        size: 'md',
                        title: 'Extracción',
                        variables: {id:r.id, donation_id:r.donation_id},
                        clickFn:'extraction'
                    }
                },{
                    type: 'button',
                    properties: {
                        disabled: r.clinic_history_status !== 'ACCEPT',
                        fill: r.donation_receipt === '' ? 'default' : 'data',                        
                        icon: fileText,
                        size: 'md',
                        title: 'Comprobante de Donacion',
                        variables: {id:r.id, file_type:r.donation_receipt},
                        clickFn:'receipt'
                    }
                },{
                    type: 'button',
                    properties: {
                        disabled: false,
                        fill: 'data',
                        icon: ic_local_offer,
                        size: 'md',
                        title: 'Etiqueta de Registro',
                        variables: {
                            file_type:'label_register_cells',
                            id:r.id,
                            extraction:'',
                            direct:false,
                            option:'print',
                            traceability:true,
                            reference_id: r.id
                        },
                        clickFn:'label_print'
                    }
                },{
                    type: 'button',
                    properties: {
                        disabled: r.donation_id === 0,
                        fill: r.donation_id === 0 ? 'default' : 'data',
                        icon: ic_local_offer,
                        size: 'md',
                        title: 'Etiqueta de Extracción',
                        variables: {
                            file_type:'label_extraction',
                            id:r.donation_id,
                            extraction: r.extraction_type,
                            direct:false,
                            option:'print',
                            traceability:true,
                            reference_id: r.id
                        },
                        clickFn:'label_print'
                    }
                },{
                    type: 'options',
                    properties: {
                        variables: r.id
                    }
                }];

                return obj;
            });

            this.setState({
                list: list
            });

            this.table.setTable();
        }
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });

        
      
        // this.updateList(e.target.value)
     
    }
    searchresult(){
        this.updateList(this.state.extraction_type_id)
    }

    updateList(id = this.state.extraction_type_id){
        this.table.resetTable();
        this.getList(id);
    }

    newRegister(){
        this.props.history.push('/cell_bank/new');
    }

    showModalDelete(id) {
        let obj = {
            title: 'Título',
            text: '¿Eliminar?',
            function: () => this.deleteOffering(id),
        }

        confirmationModal(obj);
    }

    openSampleRegister(obj){
        this.sample_register.openModal(obj.donor_id, obj.id);
    }

    openSamples(id){
        this.select_samples.openModal(id);
    }

    openClinicHistory(id){
        this.props.history.push('/cell_bank/clinic_history/CELLS/'+id);
    }

    openMedicalNotes(id) {
        this.props.history.push('/medical_notes/cells/'+id+'/0');
    }
    openExtraction(obj) {
        this.props.history.push('/cell_bank/extraction/CELLS/'+obj.id+'/'+obj.donation_id);
    }

    async onPrint(variables){
        await this.props.waiting.handleShow('Imprimiendo...');
        var obj = {
            health_facilities_id: sessionStorage.getItem("health_facilities_id"),
            id: variables.id,
            file_type: variables.file_type,
            nEtiqueta:[]
        };

        var request = await this.props.getDocumentType(obj.file_type);
        if(request){
            if(request.print_type === 'template'){
                await this.props.printDocumentTemplate(obj, request.print_automatically);
            }else if(request.print_type === 'external'){
                await this.props.printDocumentExternal(obj, request.print_automatically);
            }
        }

        await this.props.waiting.handleClose();
    }

    openModalPrintLabel(variables){
        this.print_label.openModal(
            variables.file_type, 
            variables.id,
            variables.extraction,
            variables.direct,
            variables.option,
            variables.traceability,
            variables.reference_id
        );
    }

    render(){
        return(
            <div className='col-xs-12'>
                <BreadcrumbTitle 
                    menu="Banco de Células"
                    page="Listado"
                />
                <div className='row align-items-end'>
                    <div className='col-xs-2'>
                        <label className='form-label'>Tipo de Extracción</label>
                        <select className='form-control' name='extraction_type_id' onChange={this.handleChange} value={this.state.extraction_type_id}>
                        
                            <option value='all'>TODOS</option>
                            {this.state.extraction_types.map((e, i) => (
                                <option key={i} value={e.id}>{e.donation_type_process}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-xs-2">
							<span className="span-min">Fecha Desde</span>
							<input className="form-control" type="date" name="date_ini" id="date_ini" value={this.state.date_ini} onChange={this.handleChange} />
						</div>
						<div className="col-xs-2">
							<span className="span-min">Fecha Hasta</span>
							<input className="form-control" type="date" name="date_end" id="date_end" value={this.state.date_end} onChange={this.handleChange}/>
                            </div>
                            <div className="col-xs-2">
                            <button className='btn btn-info' onClick={this.searchresult}>Buscar</button>
                            </div>
                    <div className='col-xs-10 text-right'>
                        <button className='btn btn-info' onClick={this.newRegister}>NUEVO</button>
                    </div>
                </div>
                <div className='col-xs-12 mt-3'>
                    <TableList 
                        buttons={this.state.buttons}
                        columns={this.state.columns}
                        delete={this.showModalDelete}
                        edit={this.editOffering}
                        sample_register={this.openSampleRegister}
                        samples={this.openSamples}
                        list={this.state.list}
                        clinic={this.openClinicHistory}
                        medical_notes={this.openMedicalNotes}
                        extraction={this.openExtraction}
                        receipt={this.onPrint}
                        label_print={this.openModalPrintLabel}
                        filter={true}
                        onRef={ref => this.table = ref}
                    />
                </div>

                <RegisterSample 
                    {...this.props}                     
                    screen='celulas'
                    updateList={this.updateList}
                    onRef={ref => this.sample_register = ref} 
                />
                <SelectSamples
                    {...this.props}
                    onRef={ref => this.select_samples = ref}
                />

                <PrintLabel
                    {...this.props}
                    onRef={ref => this.print_label = ref}
                />
            </div>
        )
    }
}

export default translate('translations')(CellBankList);